module.exports = __webpack_public_path__ + "img/detail.e281ad84.png";